import { render, staticRenderFns } from "./HoverBar.vue?vue&type=template&id=fbbda5be&scoped=true&"
import script from "./HoverBar.vue?vue&type=script&lang=js&"
export * from "./HoverBar.vue?vue&type=script&lang=js&"
import style0 from "./HoverBar.vue?vue&type=style&index=0&id=fbbda5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbda5be",
  null
  
)

export default component.exports